import { OwcButton, OwcChip, OwcGrid, OwcModalDialog, OwcProgressSpinner, OwcTooltip, OwcTypography } from "@one/react";
import CustomChip from "../CustomChip";
import { EQUIPMENT_DETAILS_HEADING } from "../../../constants";
import { valueOrEmpty } from "../../../utils/helpers/text";
import { useEffect, useState } from "react";
import { ViewChecklist } from "./ViewChecklist";
import { withApollo } from "react-apollo";
import { BOOKING_GET_CHECKLISTS_FOR_EQUIPMENTS } from "../../../gql/bookingapi";
import ChecklistFolder from "../../../icons/ChecklistFolder";

const PopoverAttributesDetails = ({ data, client, title, metaData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checklists, setChecklists] = useState([]);

  useEffect(() => {
    if (!data?.siteName || !data?.belongingToGroup || !data?.equipmentModel) return;
    const equipmentKey = `${data.siteName}#${data.belongingToGroup}#${data.equipmentModel}`;

    setLoading(true);
    client
      .query({
        query: BOOKING_GET_CHECKLISTS_FOR_EQUIPMENTS,
        variables: { keys: [equipmentKey] },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        const entries = res?.data?.getChecklistsForEquipments || [];
        const eqChecklists = entries?.[0]?.checklists || [];
        setChecklists(eqChecklists);
      })
      .catch((err) => console.error("Checklist fetch error:", err))
      .finally(() => setLoading(false));
  }, [data?.siteName, data?.belongingToGroup, data?.equipmentModel, client]);

  const handleOpenModal = () => {
    if (checklists.length === 1) {
      const single = checklists[0];
      if (single?.url) {
        window.open(single.url, "_blank", "noopener,noreferrer");
        return;
      }
    }
    setModalOpen(true);
  }

  const displayDataInChipsOrText = (key, data) => {
    if (key === "checklists") {
      if (!checklists?.length) return "-";
      const shortId = data?.shortIdentifier || "-";

      return (
        <button
          onClick={handleOpenModal}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            display: "inline-flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            marginTop: "4px",
          }}
          title={checklists.length === 1
            ? checklists[0]?.description || "-"
            : `Show checklists for ${shortId}`
          }
        >
          <ChecklistFolder size={20} />
          &nbsp;
          <OwcTypography variant="button" style={{ fontWeight: 600 }}>
            {shortId}
          </OwcTypography>
        </button>
      );
    }

    if (key === "qualificationStatus" || key === "systemStatus") {
      let value = valueOrEmpty(data[key], false, "-");
      return value !== "-" ? (
        <div>
          <OwcChip outlined id={`attr_${value}`}>
            {value}{" "}
          </OwcChip>
          <OwcTooltip anchor={`attr_${value}`}>{value}</OwcTooltip>
        </div>
      ) : (
        value
      );
    } else {
      return (
        <div>
          <OwcTypography variant="button" id={`attr_${key}`}>
            {valueOrEmpty(data[key], false, "-")}
          </OwcTypography>
          <OwcTooltip anchor={`attr_${key}`}>{valueOrEmpty(data[key], false, "-")}</OwcTooltip>
        </div>
      );
    }
  };

  return (<>
    <div style={{ padding: "0 1rem" }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '1.125rem 0' }}>
        <OwcTypography variant="button">
          {title}
        </OwcTypography>
        {(() => {
          if (title !== EQUIPMENT_DETAILS_HEADING) return null;
          let booked = Array.isArray(data?.bookedEquipments) ? data.bookedEquipments : null;
          if (!booked || booked.length === 0) {
            if (Array.isArray(data?.bookingEntries)) {
              booked = Array.from(new Set(
                data.bookingEntries.map(e => (e?.equipment?.shortIdentifier || e?.resource)).filter(Boolean)
              ));
            }
          }
          if (booked && booked.length >= 1) {
            return (
              <CustomChip
                text={`${booked.length}`}
                color="#fff"
                bgColor="rgba(11, 65, 205, 1)"
                compact
                info="Total items in this booking"
              />
            );
          }
          return null;
        })()}
      </div>

      <OwcGrid container columns="4" vGutter={{ m: 10, l: 15, xl: 20 }}>
        {Object.keys(metaData).map((key) => (
          <OwcGrid item l={1} m={1} xs={1} s={1} key={metaData[key].key} style={{ marginBottom: 16 }}>
            <OwcTypography variant="caption">{metaData[key].value}</OwcTypography>
            <span
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayDataInChipsOrText(key, data)}
            </span>
          </OwcGrid>
        ))}
      </OwcGrid>
    </div>

    <OwcModalDialog
      disableScrollLock
      visible={modalOpen}
      size="m"
      className="owcmodalZIndex"
      onVisibleChange={(e) => {
        e.stopPropagation();
        if (!e.target.visible) setModalOpen(false);
      }}
    >
      <div slot="header">
        <OwcTypography variant="button">
          Checklists
        </OwcTypography>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <OwcProgressSpinner diameter={60} />
        </div>
      ) : (
        <ViewChecklist equipmentDetails={data} checklists={checklists} loading={loading} minHeight={200} />
      )}

      <div slot="actions" style={{ marginLeft: "auto", display: "flex", justifyContent: "end" }}>
        <OwcButton variant="secondary" onClick={() => setModalOpen(false)}>
          Close
        </OwcButton>
      </div>
    </OwcModalDialog></>
  );
};

export default withApollo(PopoverAttributesDetails);
